import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import SoundAssetKeys from '../SoundAssetKeys';

export default class GameOverOverlay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.lblGameOver = ABCyaPhaser.Images.addImage(346, 163, UIAssetKeys._GameOver, this).setOrigin(0);

    this.lblScore = ABCyaPhaser.Images.addImage(346, 285, UIAssetKeys._Score, this).setOrigin(0);
    this.txtScore = this.scene.add.bitmapText(538, 294, 'pixelFont', '10', 48).setOrigin(0);
    this.add(this.txtScore);

    this.lblBestScore = ABCyaPhaser.Images.addImage(346, 356, UIAssetKeys._BestScore, this).setOrigin(0);
    this.txtBestScore = this.scene.add.bitmapText(514, 369, 'pixelFont', '11', 48).setOrigin(0);
    this.add(this.txtBestScore);

    this.btnGo = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._BtnGo, this).setOrigin(0);
    this.btnGo.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,() => this.clickGo());
    this.btnGo.x = this.scene.scale.width / 2 - this.btnGo.getBounds().width / 2;
    this.btnGo.y = this.scene.scale.height - 220;
  }

  displayGameOver(score, best) {
    this.txtScore.text = score.toString();
    this.txtBestScore.text = best.toString();
  };

  showGo() {
    ABCyaPhaser.Tweens.addTween(this.btnGo, 300, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.btnGo.setInteractive({ cursor: 'pointer' });
    });
  };

  clickGo() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._hoho, this.scene);
    this.scene.resetGame();
  };
}